module.exports = __webpack_public_path__ + "img/icon-7.af32ffe4.svg";